import { ComplexValue } from 'app/types-shared';
import { SafetyLimit } from 'app/area/codetable/item/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

export function syncSafetyLimits(
  currentSafetyLimits: SafetyLimit[],
  selectedKeys: ComplexValue<number>[]
): SafetyLimit[] {
  const existingByValue = new Map(currentSafetyLimits.map(sl => [sl.application.value, sl]));

  return selectedKeys
    .filter(k => isDefinedIncludingZero(k.value))
    .map(k => {
      const existingEntry = existingByValue.get(k.value);
      if (existingEntry) { return existingEntry; }
      const key = k as CodeComplexValue<number>;
      return {
        application: {
          value: key.value,
          description: key.description
        }
      } as SafetyLimit;
    });
}
